import { render, staticRenderFns } from "./StockItemTransactions.vue?vue&type=template&id=b7fcf582&"
import script from "./StockItemTransactions.vue?vue&type=script&lang=js&"
export * from "./StockItemTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports